export default {
  get forceTouchAvailable() {
    return false;
  },
};
